import { platforms } from "@/mocks/chigua";

const nav = [
  { label: "直达入口", href: "#jieru" },
  { label: "今日热议", href: "#reyi" },
  { label: "围观指南", href: "#zhinan" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="inline-flex items-center gap-2.5" aria-label="回到顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">
                吃瓜<span className="text-primary-600">路线</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              全网热点平台入口与讨论方向的聚合导航站。一个页面直达微博、抖音、贴吧、B站等现场，
              方便快捷围观每一场网络盛事，也提醒你保持理性、尊重他人。
            </p>
            <p className="mt-5 inline-flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line" aria-hidden="true"></i>
              建议与反馈：guanzhu@example.com
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold tracking-wide text-foreground-950">站点导航</h3>
            <ul className="mt-4 space-y-2.5">
              {nav.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="inline-flex items-center gap-1.5 text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-semibold tracking-wide text-foreground-950">平台直达</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {platforms.map((p) => (
                <a
                  key={p.name}
                  href={p.url}
                  target="_blank"
                  rel="noopener nofollow noreferrer"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-secondary-200 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${p.icon} text-sm`} aria-hidden="true"></i>
                  {p.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 吃瓜路线 · 仅提供各平台公开入口与讨论方向整理
          </p>
          <p className="text-xs text-foreground-600">理性围观 · 尊重他人 · 拒绝谣言</p>
        </div>
      </div>
    </footer>
  );
}